import { ABaseModel } from '../abstracts/ABaseModel.js';
import { IActivity, IActivityListResult, IActivityPaginationResult } from '../interfaces/Activity.js';
import { Image } from './Image.js';
import { ListResult, PaginationResult } from './List.js';

/**
 * Activity
 */
class Activity extends ABaseModel implements IActivity {
  id: number;
  type: string;
  activityDate: string;
  creatorType: string;
  creatorId: number;
  creatorSubType: string;
  creatorSubId: number;
  creatorRole: string;
  creatorSlug: string;
  creatorName: string;
  creatorImages: Array<Image>;
  ownerType: string;
  ownerId: number;
  ownerRole: string;
  ownerAlias: string;
  ownerName: string;
  objectType: string;
  objectId: number;
  objectRole: string;
  objectSlug: string;
  objectName: string;
  objectDate: string;
  objectValue: string;
  objectSubType: string;
  objectSubId: number;
  objectImages: Array<Image>;
  objectArtId: number;
  objectArtTitle: string;
  objectArtSlug: string;
  objectArtImages: Array<Image>;
  objectArtArtistId: number;
  objectArtArtistAlias: string;
  objectArtArtistName: string;
  objectArtArtistImages: Array<Image>;

  /**
   * constructor
   */
  constructor() {
    super();
  }
}

/**
 * ActivityListResult
 */
class ActivityListResult extends ListResult implements IActivityListResult {
  declare items: Array<Activity>;

  /**
   * constructor
   */
  constructor() {
    super();
  }
}

/**
 * ActivityPaginationResult
 */
class ActivityPaginationResult extends PaginationResult implements IActivityPaginationResult {
  declare items: Array<Activity>;

  /**
   * constructor
   */
  constructor() {
    super();
  }
}

export { Activity, ActivityListResult, ActivityPaginationResult };
